import {
  getToken,
  setToken,
  removeToken,
  getUserInfo,
  setUserInfo,
  removeUserInfo,
  setUserTableColumn,
  getUserTableColumn
} from '../../utils/auth';
import { Message } from 'element-ui';
import {
  login,
  getInfo
} from '../../api/login';

const user = {
  state: {
    token: getToken(),
    userInfo: getUserInfo(),
    defaultBranch: null,
    defaultHotel: null
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    setDefaultBranch: (state, branch) => {
      state.defaultBranch = branch;
    },
    setDefaultHotel: (state, hotel) => {
      state.defaultHotel = hotel;
    },
    logout (state, vm) {
      removeToken();
      removeUserInfo();
      // 清空打开的页面等数据，但是保存主题数据
      let theme = '';
      if (localStorage.theme) {
        theme = localStorage.theme;
      }
      var tableColumn = getUserTableColumn();
      localStorage.clear();
      setUserTableColumn(tableColumn);
      if (theme) {
        localStorage.theme = theme;
      }
    }
  },
  actions: {
    Login ({commit}, userInfo) {
      const username = userInfo.username.trim();
      commit('SET_TOKEN', '');
      removeToken();
      commit('SET_USERINFO', null);
      removeUserInfo();
      return new Promise((resolve, reject) => {
        login(username, userInfo.password, userInfo.captcha, userInfo.systemPwdLogin).then(response => {
          if (response.status === 200) {
            setToken(response.data);
            commit('SET_TOKEN', response.data);
            resolve();
          } else {
            Message.error(response.message || '登录失败');
            reject(response);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 获取用户信息
    GetInfo ({commit, state}) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          if ((response.status && response.status === 500) || (response.menus && !response.menus.length)) {
            commit('logout')
            reject(response.menus ? {status: 500, message: '您暂无此应用权限'} : response);
            return;
          }
          let data = response;

          commit('SET_USERINFO', data);
          setUserInfo(data);
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js